import { AxiosResponse } from 'axios'

import axios from 'services'

export const getKeycloakId = (email: string): Promise<AxiosResponse<string>> =>
  axios.get(`/v1/identities-eos/keycloak-id/${encodeURIComponent(email)}`)
